import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { optimizeImageUrlHeight } from "@faire/web/common/images/optimizeImages";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import { StoreType } from "@faire/web/common/StoreType";

export interface IHeaderImage {
  src: string;
  zIndex: number;
  dimensions: { [viewport: string]: IHeaderImageDimensions };
}

export interface IHeaderImageDimensions {
  height: string;
  top: string;
  left?: string;
  right?: string;
}

const convertToHeightOptimizedImage = (
  url: string,
  isSSR: boolean,
  height: number
): string => {
  return (
    optimizeImageUrlHeight(
      IImage.build({
        url: url,
      }),
      isSSR,
      height
    ) ?? url
  );
};

export const useHeaderImagesFaireAcademy = (): IHeaderImage[] => {
  const isSSR = useIsSSR();

  return [
    {
      src: convertToHeightOptimizedImage(
        "https://cdn.faire.com/fastly/c4bf31cc6fe7f282e0c0800787868e789e013c6052bd23f7f26066aa103ab0ed.jpeg",
        isSSR,
        356
      ),
      zIndex: 2,
      dimensions: {
        xlarge: {
          height: "356px",
          top: "24px",
          left: "58px",
        },
        desktop: {
          height: "285px",
          top: "158px",
          left: "3%",
        },
        tablet: {
          height: "225px",
          top: "190px",
          left: "-2%",
        },
        mobile: {
          height: "166px",
          top: "-267px",
          left: "12%",
        },
      },
    },
    {
      src: convertToHeightOptimizedImage(
        "https://cdn.faire.com/fastly/682096084aaf3bc97293e5dee4efd675b1942920849b047e71245156381ede4e.png",
        isSSR,
        265
      ),
      zIndex: 1,
      dimensions: {
        xlarge: {
          height: "265px",
          top: "-135px",
          left: "15%",
        },
        desktop: {
          height: "212px",
          top: "18px",
          left: "13%",
        },
        tablet: {
          height: "190px",
          top: "67px",
          left: "9%",
        },
        mobile: {
          height: "124px",
          top: "-302px",
          left: "0%",
        },
      },
    },
    {
      src: convertToHeightOptimizedImage(
        "https://cdn.faire.com/fastly/dd912dfa34d3816de8b751489db17747667acf4d7ef7e413971154d71af074ea.jpeg",
        isSSR,
        228
      ),
      zIndex: 1,
      dimensions: {
        xlarge: {
          height: "228px",
          top: "-125px",
          right: "15%",
        },
        desktop: {
          height: "183px",
          top: "62px",
          right: "12%",
        },
        tablet: {
          height: "164px",
          top: "67px",
          right: "9%",
        },
        mobile: {
          height: "109px",
          top: "-320px",
          right: "8%",
        },
      },
    },
    {
      src: convertToHeightOptimizedImage(
        "https://cdn.faire.com/fastly/06f82b1fab2417a8ec09d62d68b29c4dc7d3602d980b765db851c4aaf0631a40.png",
        isSSR,
        254
      ),
      zIndex: 1,
      dimensions: {
        xlarge: {
          height: "254px",
          top: "183px",
          right: "1%",
        },
        desktop: {
          height: "203px",
          top: "334px",
          right: "0%",
        },
        tablet: {
          height: "160px",
          top: "300px",
          right: "0%",
        },
        mobile: {
          height: "103px",
          top: "-180px",
          right: "0%",
        },
      },
    },
  ];
};

export const useHeaderImagesPartialRetailersCafeRestaurantDefault =
  (): IHeaderImage[] => {
    const isSSR = useIsSSR();

    return [
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/ba5e90e9050727deca1d29d565d1a4c71ea4241b061d7d2cd6d6fd6b76c3baa6.png",
          isSSR,
          356
        ),
        zIndex: 2,
        dimensions: {
          xlarge: {
            height: "356px",
            top: "24px",
            left: "58px",
          },
          desktop: {
            height: "285px",
            top: "158px",
            left: "3%",
          },
          tablet: {
            height: "225px",
            top: "190px",
            left: "-2%",
          },
          mobile: {
            height: "166px",
            top: "-267px",
            left: "12%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/c200ede9dcb9ae5f6721238315cb011e61064d07c489865c30c4bdcc4842731a.png",
          isSSR,
          265
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "265px",
            top: "-135px",
            left: "15%",
          },
          desktop: {
            height: "212px",
            top: "18px",
            left: "13%",
          },
          tablet: {
            height: "190px",
            top: "67px",
            left: "9%",
          },
          mobile: {
            height: "124px",
            top: "-302px",
            left: "0%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/b0f3adc5c1384646e5d98e27a6dcb1fa1751d26cafa66e2788cd16f5cdfd147e.png",
          isSSR,
          228
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "228px",
            top: "-125px",
            right: "15%",
          },
          desktop: {
            height: "183px",
            top: "62px",
            right: "12%",
          },
          tablet: {
            height: "164px",
            top: "67px",
            right: "9%",
          },
          mobile: {
            height: "109px",
            top: "-320px",
            right: "8%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/7605f7995d2518649847718fff424270a1bcb9f51d62022e7127b403f2ef5372.png",
          isSSR,
          254
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "254px",
            top: "183px",
            right: "1%",
          },
          desktop: {
            height: "203px",
            top: "334px",
            right: "0%",
          },
          tablet: {
            height: "160px",
            top: "300px",
            right: "0%",
          },
          mobile: {
            height: "103px",
            top: "-180px",
            right: "0%",
          },
        },
      },
    ];
  };

export const useHeaderImagesPartialRetailersSpaSalonDefault =
  (): IHeaderImage[] => {
    const isSSR = useIsSSR();

    return [
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/994aff53f758bd3a4b02c4bc1cd813d6843b57227e4e663da304e19c4e300a28.png",
          isSSR,
          356
        ),
        zIndex: 2,
        dimensions: {
          xlarge: {
            height: "356px",
            top: "24px",
            left: "58px",
          },
          desktop: {
            height: "285px",
            top: "158px",
            left: "3%",
          },
          tablet: {
            height: "225px",
            top: "190px",
            left: "-2%",
          },
          mobile: {
            height: "166px",
            top: "-267px",
            left: "12%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/0dd530be318ecdb3976121a94028f57b5854262bd0d49d77e3d4af399f2c2c7e.png",
          isSSR,
          265
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "265px",
            top: "-135px",
            left: "15%",
          },
          desktop: {
            height: "212px",
            top: "18px",
            left: "13%",
          },
          tablet: {
            height: "190px",
            top: "67px",
            left: "9%",
          },
          mobile: {
            height: "124px",
            top: "-302px",
            left: "0%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/3eca7d2f81682d4bc050acd160dadd47640f4504298e2bdd36206a2ef77c3500.png",
          isSSR,
          228
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "228px",
            top: "-125px",
            right: "15%",
          },
          desktop: {
            height: "183px",
            top: "62px",
            right: "12%",
          },
          tablet: {
            height: "164px",
            top: "67px",
            right: "9%",
          },
          mobile: {
            height: "109px",
            top: "-320px",
            right: "8%",
          },
        },
      },
      {
        src: convertToHeightOptimizedImage(
          "https://cdn.faire.com/fastly/b7193c8706f0a5f1aba33b7d66bde8e3da8a3ddb73da76882c7a93fa8e25ec8d.png",
          isSSR,
          254
        ),
        zIndex: 1,
        dimensions: {
          xlarge: {
            height: "254px",
            top: "183px",
            right: "1%",
          },
          desktop: {
            height: "203px",
            top: "334px",
            right: "0%",
          },
          tablet: {
            height: "160px",
            top: "300px",
            right: "0%",
          },
          mobile: {
            height: "103px",
            top: "-180px",
            right: "0%",
          },
        },
      },
    ];
  };

export const useHeaderImagesPartialRetailersCafeRestaurantRotating =
  (): IHeaderImage[][] => {
    const isSSR = useIsSSR();

    const imagesData = [
      [
        "https://cdn.faire.com/fastly/ba5e90e9050727deca1d29d565d1a4c71ea4241b061d7d2cd6d6fd6b76c3baa6.png",
        "https://cdn.faire.com/fastly/c200ede9dcb9ae5f6721238315cb011e61064d07c489865c30c4bdcc4842731a.png",
        "https://cdn.faire.com/fastly/b0f3adc5c1384646e5d98e27a6dcb1fa1751d26cafa66e2788cd16f5cdfd147e.png",
        "https://cdn.faire.com/fastly/7605f7995d2518649847718fff424270a1bcb9f51d62022e7127b403f2ef5372.png",
      ],
      [
        "https://cdn.faire.com/fastly/f7dad3ff7b7fdae2f3edbfc7ceb458c586371c28fad27e28a271ce65918a3021.png",
        "https://cdn.faire.com/fastly/647cfd4c894d10650f2d9e0c96517bac9deb5a5f207e24372d230d72d7641b1c.png",
        "https://cdn.faire.com/fastly/4106f276e3e01b748751d7ee91c387e4f53b9f406dda6ccab83012bc17f537d4.png",
        "https://cdn.faire.com/fastly/a9ffd672ed36ae4eea4e3d1c9cdc8054522cf89fd698e448d074ebf78b192b89.png",
      ],
      [
        "https://cdn.faire.com/fastly/d9e81759edafbc48a6be641b8ab88e06929ae043331ec0fd1e61bc503c301c48.png",
        "https://cdn.faire.com/fastly/05c6014de34a77695121d98691bbf3dfb57ba19b46487e9d7c684984728bdba4.png",
        "https://cdn.faire.com/fastly/19d9ce1786e3859fe785cf26ea47620551257ccdf07a4fb5618e6f416737d794.png",
        "https://cdn.faire.com/fastly/43c7d6e645506f9d1db981d952b890b584d9fa8fe4060ca82f7cafee9a58116b.png",
      ],
      [
        "https://cdn.faire.com/fastly/28885eae615e24ba0d33d8ff067ab40f54c18c4814a4bdadf2d80c5c3746667c.png",
        "https://cdn.faire.com/fastly/d6503a0ee6a6967ee80668a457e0210247e027300de6b0662823788aeb3c66a4.png",
        "https://cdn.faire.com/fastly/fd1da9b0fc25df135ca03603fbc271cf3c8821f379a5bf76c3c35d79f19fe193.png",
        "https://cdn.faire.com/fastly/0ea3f79f81555e9831808bd8b90fb17f60f27587a4abff95f0103a4c038225dc.png",
      ],
    ];

    return imagesData.map((imageData) => {
      return [
        {
          src: convertToHeightOptimizedImage(
            imageData[0] ??
              "https://cdn.faire.com/fastly/ba5e90e9050727deca1d29d565d1a4c71ea4241b061d7d2cd6d6fd6b76c3baa6.png",
            isSSR,
            356
          ),
          zIndex: 2,
          dimensions: {
            xlarge: {
              height: "356px",
              top: "24px",
              left: "58px",
            },
            desktop: {
              height: "285px",
              top: "158px",
              left: "3%",
            },
            tablet: {
              height: "225px",
              top: "190px",
              left: "-2%",
            },
            mobile: {
              height: "166px",
              top: "-267px",
              left: "12%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[1] ??
              "https://cdn.faire.com/fastly/c200ede9dcb9ae5f6721238315cb011e61064d07c489865c30c4bdcc4842731a.png",
            isSSR,
            265
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "265px",
              top: "-135px",
              left: "15%",
            },
            desktop: {
              height: "212px",
              top: "18px",
              left: "13%",
            },
            tablet: {
              height: "190px",
              top: "67px",
              left: "9%",
            },
            mobile: {
              height: "124px",
              top: "-302px",
              left: "0%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[2] ??
              "https://cdn.faire.com/fastly/b0f3adc5c1384646e5d98e27a6dcb1fa1751d26cafa66e2788cd16f5cdfd147e.png",
            isSSR,
            228
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "228px",
              top: "-125px",
              right: "15%",
            },
            desktop: {
              height: "183px",
              top: "62px",
              right: "12%",
            },
            tablet: {
              height: "164px",
              top: "67px",
              right: "9%",
            },
            mobile: {
              height: "109px",
              top: "-320px",
              right: "8%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[3] ??
              "https://cdn.faire.com/fastly/7605f7995d2518649847718fff424270a1bcb9f51d62022e7127b403f2ef5372.png",
            isSSR,
            254
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "254px",
              top: "183px",
              right: "1%",
            },
            desktop: {
              height: "203px",
              top: "334px",
              right: "0%",
            },
            tablet: {
              height: "160px",
              top: "300px",
              right: "0%",
            },
            mobile: {
              height: "103px",
              top: "-180px",
              right: "0%",
            },
          },
        },
      ];
    });
  };

export const useHeaderImagesPartialRetailersSpaSalonRotating =
  (): IHeaderImage[][] => {
    const isSSR = useIsSSR();

    const imagesData = [
      [
        "https://cdn.faire.com/fastly/bf578dbb587e4ef6738ff6d40dc4ff34f83d423a5c9633bbc737d1c55a0fa314.png",
        "https://cdn.faire.com/fastly/d1eafc864359ead2afa1f3a1b9c97d70588191c975fd9caa3985330f3387eeef.png",
        "https://cdn.faire.com/fastly/e303620ddf77dab0666e6d6167fa78c46e854b96376a784d03f9fd9c6d8879aa.png",
        "https://cdn.faire.com/fastly/95048895d5d3252d604089741f043ce94c3fd5ceda89f274ea14945e671bf267.png",
      ],
      [
        "https://cdn.faire.com/fastly/d478b0f5b051bcf7a57cc6f0f216bcde2c047585c47eb0c1e3c76682709dd7aa.png",
        "https://cdn.faire.com/fastly/6e9bdd1b7fea576d1b5ea93ca3e6941f2be98fd02626ad472792ab9f2c825336.png",
        "https://cdn.faire.com/fastly/c210044dc72871fcbae8ff5f6a67a3bd11426a1594872e1e21f5ee12a042f69f.png",
        "https://cdn.faire.com/fastly/752a68fe69c867d7b8ab224320e94dd68acb0a5b32d8e5db6ec5370ac2022c21.png",
      ],
      [
        "https://cdn.faire.com/fastly/994aff53f758bd3a4b02c4bc1cd813d6843b57227e4e663da304e19c4e300a28.png",
        "https://cdn.faire.com/fastly/0dd530be318ecdb3976121a94028f57b5854262bd0d49d77e3d4af399f2c2c7e.png",
        "https://cdn.faire.com/fastly/3eca7d2f81682d4bc050acd160dadd47640f4504298e2bdd36206a2ef77c3500.png",
        "https://cdn.faire.com/fastly/b7193c8706f0a5f1aba33b7d66bde8e3da8a3ddb73da76882c7a93fa8e25ec8d.png",
      ],
      [
        "https://cdn.faire.com/fastly/b393e3d900ca6007ba37d7c4a089217aa65de4b9c6ca8714c4e5bd98d74e00ca.png",
        "https://cdn.faire.com/fastly/4819e500df482d6d36ebc3d811b94947d99dbe6ab8e34ec9ef4f72379a5dcdaf.png",
        "https://cdn.faire.com/fastly/7f49c1f4a4d458d7b3f948ffde283a563d04237f6f12c02d63bc13c99902687c.png",
        "https://cdn.faire.com/fastly/453e32a87715c9f07c32839bd655bc53f6ef5cc7dc32f8a6f17a6f5a443bcb02.png",
      ],
    ];

    return imagesData.map((imageData) => {
      return [
        {
          src: convertToHeightOptimizedImage(
            imageData[0] ??
              "https://cdn.faire.com/fastly/bf578dbb587e4ef6738ff6d40dc4ff34f83d423a5c9633bbc737d1c55a0fa314.png",
            isSSR,
            356
          ),
          zIndex: 2,
          dimensions: {
            xlarge: {
              height: "356px",
              top: "24px",
              left: "58px",
            },
            desktop: {
              height: "285px",
              top: "158px",
              left: "3%",
            },
            tablet: {
              height: "225px",
              top: "190px",
              left: "-2%",
            },
            mobile: {
              height: "166px",
              top: "-267px",
              left: "12%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[1] ??
              "https://cdn.faire.com/fastly/d1eafc864359ead2afa1f3a1b9c97d70588191c975fd9caa3985330f3387eeef.png",
            isSSR,
            265
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "265px",
              top: "-135px",
              left: "15%",
            },
            desktop: {
              height: "212px",
              top: "18px",
              left: "13%",
            },
            tablet: {
              height: "190px",
              top: "67px",
              left: "9%",
            },
            mobile: {
              height: "124px",
              top: "-302px",
              left: "0%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[2] ??
              "https://cdn.faire.com/fastly/e303620ddf77dab0666e6d6167fa78c46e854b96376a784d03f9fd9c6d8879aa.png",
            isSSR,
            228
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "228px",
              top: "-125px",
              right: "15%",
            },
            desktop: {
              height: "183px",
              top: "62px",
              right: "12%",
            },
            tablet: {
              height: "164px",
              top: "67px",
              right: "9%",
            },
            mobile: {
              height: "109px",
              top: "-320px",
              right: "8%",
            },
          },
        },
        {
          src: convertToHeightOptimizedImage(
            imageData[3] ??
              "https://cdn.faire.com/fastly/95048895d5d3252d604089741f043ce94c3fd5ceda89f274ea14945e671bf267.png",
            isSSR,
            254
          ),
          zIndex: 1,
          dimensions: {
            xlarge: {
              height: "254px",
              top: "183px",
              right: "1%",
            },
            desktop: {
              height: "203px",
              top: "334px",
              right: "0%",
            },
            tablet: {
              height: "160px",
              top: "300px",
              right: "0%",
            },
            mobile: {
              height: "103px",
              top: "-180px",
              right: "0%",
            },
          },
        },
      ];
    });
  };

export const getRotatingWords = (storeType: string | undefined) => {
  const cafeRestaurantWords = ["eatery", "café", "market", "bistro"];
  const spaSalonWords = ["spa", "salon", "studio", "barber"];

  if (storeType === StoreType.CAFE_OR_RESTAURANT) {
    return cafeRestaurantWords;
  } else if (storeType === StoreType.SPA_OR_SALON) {
    return spaSalonWords;
  }

  return null;
};

const DREAM_POSITIONING_CAFE_OR_RESTAURANT: { [viewport: string]: string[] } = {
  desktop: ["0px", "32px", "0px", "4px"],
  tablet: ["0px", "22px", "0px", "2px"],
  mobile: ["17px", "35px", "9px", "20px"],
};
const DREAM_POSITIONING_SPA_OR_SALON: { [viewport: string]: string[] } = {
  desktop: ["40px", "11px", "0px", "0px"],
  tablet: ["29px", "8px", "0px", "0px"],
  mobile: ["39px", "24px", "17px", "14px"],
};
const WORD_POSITIONING_CAFE_OR_RESTAURANT: { [viewport: string]: string[] } = {
  desktop: ["226px", "256px", "228px", "232px"],
  tablet: ["163px", "185px", "165px", "167px"],
  mobile: ["137px", "154px", "130px", "141px"],
};
const WORD_POSITIONING_SPA_OR_SALON: { [viewport: string]: string[] } = {
  desktop: ["270px", "240px", "228px", "228px"],
  tablet: ["193px", "172px", "165px", "165px"],
  mobile: ["160px", "145px", "137px", "135px"],
};

export const getDreamPositioning = (
  storeType: string | undefined,
  isMobile: boolean,
  isTablet: boolean
) => {
  let viewport = "desktop";

  if (isMobile) {
    viewport = "mobile";
  } else if (isTablet) {
    viewport = "tablet";
  }

  return storeType === StoreType.CAFE_OR_RESTAURANT
    ? DREAM_POSITIONING_CAFE_OR_RESTAURANT[viewport]
    : DREAM_POSITIONING_SPA_OR_SALON[viewport];
};

export const getWordPositioning = (
  storeType: string | undefined,
  isMobile: boolean,
  isTablet: boolean
) => {
  let viewport = "desktop";

  if (isMobile) {
    viewport = "mobile";
  } else if (isTablet) {
    viewport = "tablet";
  }

  return storeType === StoreType.CAFE_OR_RESTAURANT
    ? WORD_POSITIONING_CAFE_OR_RESTAURANT[viewport]
    : WORD_POSITIONING_SPA_OR_SALON[viewport];
};
